import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppListViewComponent } from './app-list-view.component';
import { SharedModule } from '../shared/shared.module';
import { PipesModule } from 'app/pipes/pipes.module';

@NgModule({
  declarations: [AppListViewComponent],
  exports: [AppListViewComponent],
  imports: [CommonModule, FormsModule, SharedModule, PipesModule],
  providers: []
})
export class AppListViewModule {}
